import { Container, withStyles } from '@material-ui/core';
const PageHeader = withStyles((theme) => ({
    root: {
        position: 'relative',
        width: '100%',
        maxWidth: '100%',
        backgroundColor: theme.palette.primary.light,
        borderBottomLeftRadius: theme.spacing(10),
        borderBottomRightRadius: theme.spacing(10),
        padding: theme.spacing(0),
        paddingTop: 'env(safe-area-inset-top)',
        [theme.breakpoints.up('md')]: {
            backgroundColor: theme.palette.common.white,
        },
        '&::before': {
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 1,
            width: '100%',
            maxWidth: '100%',
            backgroundColor: theme.palette.primary.light,
        },
    },
}), { name: 'PageHeader' })(Container);
export default PageHeader;
